import { lazy } from 'react';

// General purpose page components and the ones used on multiple routes in the app.
export const Mailpiece = lazy(() => import('../pages/MailpiecePage'));
export const Page404 = lazy(() => import('../pages/Page404'));
export const Page500 = lazy(() => import('../pages/Page500'));
export const AuthCallback = lazy(() => import('../pages/AuthCallback'));

// "Auth" routes group.
export const AuthRegister = lazy(() => import('../pages/AuthRegister'));

// "User" routes group.
export const UserAccount = lazy(() => import('../pages/UserAccount'));

// "Administration" routes group.
export const AdministrationAccountSetup = lazy(() => import('../pages/Administration//AccountSetup'));
export const AdministrationCompany = lazy(() => import('../pages/Administration//Company'));
export const AdministrationPurchasePlan = lazy(() => import('../pages/Administration//PurchasePlan'));
export const AdministrationMailroom = lazy(() => import('../pages/Administration/Mailroom'));
export const AdministrationUsersManagement = lazy(() => import('../pages/Administration/UsersManagement'));
export const AdministrationUserCreate = lazy(() => import('../pages/Administration/UserCreate'));
export const AdministrationUserEdit = lazy(() => import('../pages/Administration/UserEdit'));
export const AdministrationUsersUpload = lazy(() => import('../pages/Administration/UsersUpload'));
export const AdministrationAutomations = lazy(() => import('../pages/Administration/Automations'));
export const AdministrationAutomationsConflicts = lazy(() => import('../pages/Administration/AutomationsConflicts'));
export const AdministrationAutomationCreate = lazy(
  () => import('../pages/Administration/Automations/AutomationCreate'),
);
export const AdministrationAutomationEdit = lazy(() => import('../pages/Administration/Automations/AutomationEdit'));
export const AdministrationRoutes = lazy(() => import('../pages/Administration/Routes'));
export const AdministrationRoute = lazy(() => import('../pages/Administration/Route'));
export const AdministrationLocations = lazy(() => import('../pages/Administration/Locations'));
export const AdministrationLocation = lazy(() => import('../pages/Administration/Location'));
export const AdministrationGroupsList = lazy(() => import('../pages/Administration/Groups/List'));
export const AdministrationGroupsEdit = lazy(() => import('../pages/Administration/Groups/Edit'));
export const AdministrationNotificationTemplates = lazy(
  () => import('../pages/Administration/NotificationTemplates/List'),
);
export const AdministrationEditNotificationTemplates = lazy(
  () => import('../pages/Administration/NotificationTemplates/Edit'),
);

//KT routes
export const Onboarding = lazy(() => import('../pages/kt/Onboarding'));
export const CreateCompany = lazy(() => import('../pages/kt/CreateCompany'));

// "Mailroom" routes group.
export const MailroomDashboard = lazy(() => import('../pages/MailroomDashboard'));
export const MailroomStorageGroupContent = lazy(() => import('../pages/MailroomStorageGroupContent'));
export const MailroomActiveItems = lazy(() => import('../pages/MailroomActiveItems'));
export const MailroomActiveStorageGroups = lazy(() => import('../pages/MailroomActiveStorageGroups'));
export const MailroomPendingRequests = lazy(() => import('../pages/MailroomPendingRequests'));
export const MailroomSearch = lazy(() => import('../pages/MailroomSearch'));
export const MailroomReceiveSessions = lazy(() => import('../pages/MailroomReceiveSessions'));

// "Inbox" routes group.
export const Inbox = lazy(() => import('../pages/Inbox'));
